// Viewport height fix for mobile browsers
// This addresses the issue where 100vh doesn't account for browser UI on mobile devices

export function applyViewportFix() {
  // First we get the viewport height and multiply it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  
  // We also handle orientation changes
  window.addEventListener('resize', () => {
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  // iOS specific fixes
  applyIOSFixes();
}

// Specific fixes for iOS devices
function applyIOSFixes() {
  // Detect iOS
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  if (isIOS) {
    // Apply iOS-specific CSS class to the body
    document.body.classList.add('ios-device');
    
    // Fix for iOS Safari viewport issues
    document.documentElement.style.setProperty('--safe-area-inset-top', 'env(safe-area-inset-top)');
    document.documentElement.style.setProperty('--safe-area-inset-right', 'env(safe-area-inset-right)');
    document.documentElement.style.setProperty('--safe-area-inset-bottom', 'env(safe-area-inset-bottom)');
    document.documentElement.style.setProperty('--safe-area-inset-left', 'env(safe-area-inset-left)');
    
    // Fix for iOS Safari 100vh issue
    const fixIOSHeight = () => {
      const viewportHeight = window.innerHeight;
      document.documentElement.style.setProperty('--ios-viewport-height', `${viewportHeight}px`);
    };
    
    // Apply on load and resize
    fixIOSHeight();
    window.addEventListener('resize', fixIOSHeight);
    window.addEventListener('orientationchange', fixIOSHeight);
  }
}
